import { createLawnOpsClient, isUsableConfig } from "@lawnops/api-client";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabase = createLawnOpsClient({ url, anonKey });
export const isSupabaseConfigured = isUsableConfig(url, anonKey);
